var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "genre-category-setting-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _setup.onClickCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialogRoot",
          staticClass: "genre-category-setting-dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _setup.titleId,
            tabindex: "-1",
          },
        },
        [
          _c(
            "header",
            { staticClass: "genre-category-setting-dialog__header" },
            [
              _c("div", {
                staticClass: "genre-category-setting-dialog__header-spacer",
                attrs: { "aria-hidden": "true" },
              }),
              _c(
                "h2",
                {
                  staticClass: "genre-category-setting-dialog__title",
                  attrs: { id: _setup.titleId },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("novelDetail.genreCategorySetting.title")) +
                      " "
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "genre-category-setting-dialog__close",
                  attrs: {
                    type: "button",
                    "aria-label": String(_vm.$t("common.close")),
                  },
                  on: { click: _setup.onClickCancel },
                },
                [_c(_setup.IconClose)],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "genre-category-setting-section" }, [
            _c(
              "h3",
              {
                staticClass: "genre-category-setting-label",
                attrs: { id: _setup.categorySelectLabelId },
              },
              [_vm._v(" " + _vm._s(_vm.$t("novelDetail.categoryLabel")) + " ")]
            ),
            _c(
              "div",
              { staticClass: "genre-category-setting-select-wrap" },
              [
                _c(
                  "select",
                  {
                    staticClass: "genre-category-setting-select",
                    attrs: { "aria-labelledby": _setup.categorySelectLabelId },
                    domProps: { value: _setup.genreId ?? "" },
                    on: { change: _setup.onChangeGenre },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "novelDetail.genreCategorySetting.categoryPlaceholder"
                          )
                        )
                      ),
                    ]),
                    _vm._l(_setup.translatedGenreList, function (item) {
                      return _c(
                        "option",
                        { key: item.id, domProps: { value: item.id } },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      )
                    }),
                  ],
                  2
                ),
                _c(_setup.IconChevronDown, {
                  staticClass: "genre-category-setting-select-icon",
                  attrs: { "aria-hidden": "true" },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "genre-category-setting-section" }, [
            _c("h3", { staticClass: "genre-category-setting-label" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("novelDetail.genreLabel")) +
                  _vm._s(
                    _vm.$t("novelDetail.genreCategorySetting.genreHint", {
                      count: _setup.MAX_CATEGORY_COUNT,
                    })
                  ) +
                  " "
              ),
            ]),
            _c(
              "div",
              { staticClass: "genre-category-setting-pills" },
              _vm._l(_setup.translatedCategoryList, function (item) {
                return _c(
                  "button",
                  {
                    key: item.id,
                    staticClass: "genre-category-setting-pill",
                    class: { selected: _setup.categoryIds.includes(item.id) },
                    attrs: {
                      type: "button",
                      "aria-pressed": _setup.categoryIds.includes(item.id),
                      disabled:
                        !_setup.categoryIds.includes(item.id) &&
                        _setup.categoryIds.length >= _setup.MAX_CATEGORY_COUNT,
                    },
                    on: {
                      click: function ($event) {
                        return _setup.onToggleCategory(item.id)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.name) + " ")]
                )
              }),
              0
            ),
          ]),
          _c(
            "button",
            {
              staticClass: "genre-category-setting-update-button",
              attrs: {
                type: "button",
                disabled: _setup.isSaving || !_setup.canSubmit,
              },
              on: { click: _setup.onClickUpdate },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("novelDetail.genreCategorySetting.updateButton")
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "genre-category-setting-cancel-button",
              attrs: { type: "button", disabled: _setup.isSaving },
              on: { click: _setup.onClickCancel },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }